import React, { useEffect, useState } from "react";
import { Card, Button, Form } from "react-bootstrap";
import usePageTracking from "../../hooks/usePageTracking";
import {
  activityEnd,
  activityStart,
} from "../../redux/slices/trackActivitySlice";
import { useDispatch } from "react-redux";

const Newsletter = () => {
  const dispatch = useDispatch();

  // Track Activity
  usePageTracking("NEWSLETTER");

  useEffect(() => {
    const payload = {
      page_name: "NEWSLETTER",
      platform: "web",
    };

    dispatch(activityStart(payload));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        activityEnd({
          page_name: "NEWSLETTER",
        }),
      );
    };
  }, [dispatch]);

  

  return (
    <div className="newsletter-content">
      <Card className="pb-0 mb-0">
        <Card.Body>
          <div style={{ height: "100vh", width: "100%", overflow: "hidden" }}>
            <iframe
              src="https://newsletter.mapmypay.com/"
              title="MapMyPay Newsletter"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Newsletter;
